module.exports = __webpack_public_path__ + "media/images/japan/place_2-6ba8d7f67d08a1f635b8a21054423abd.png";